import { render, staticRenderFns } from "./AuthModal.vue?vue&type=template&id=fd896630&scoped=true&"
import script from "./AuthModal.vue?vue&type=script&lang=js&"
export * from "./AuthModal.vue?vue&type=script&lang=js&"
import style0 from "./AuthModal.vue?vue&type=style&index=0&id=fd896630&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd896630",
  null
  
)

export default component.exports